<section class="gates">
  <div class="gates__head">
    <span class="gates__icon" aria-hidden="true"><i class="pi pi-filter"></i></span>
    <div class="gates__titles">
      <h2 class="gates__title">Gates de elegibilidade</h2>
      <p class="gates__subtitle">
        Calculados com os números extraídos dos documentos da empresa
        @if (gates()?.fiscalYear) {
          · exercício {{ gates()!.fiscalYear }}
        }
      </p>
    </div>
    @if (gates(); as g) {
      @let badge = overallBadge(g);
      <span class="gate-tag gate-tag--{{ badge.tone }}">
        <i class="pi {{ badge.icon }}" aria-hidden="true"></i>
        {{ badge.text }}
      </span>
    }
  </div>

  @if (loading()) {
    <p class="gates__state">Calculando os gates...</p>
  } @else if (error()) {
    <div class="gates__state gates__state--error" role="alert">
      <strong>{{ error() }}</strong>
      <app-button
        [label]="'Tentar de novo'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="load()" />
    </div>
  } @else if (gates(); as g) {
    <!-- Card 3300: documento processando não é "sem dados". O painel acompanha e recarrega sozinho.
         A região viva fica sempre no DOM e só o conteúdo entra e sai, para o leitor de tela anunciar. -->
    <div role="status" aria-live="polite">
      @if (processing()?.isProcessing) {
        <div class="gates__processing">
          <i
            class="pi"
            [class.pi-spin]="!isTrackingStopped()"
            [class.pi-spinner]="!isTrackingStopped()"
            [class.pi-info-circle]="isTrackingStopped()"
            aria-hidden="true"></i>
          <div>
            <strong>{{ describeProcessing(processing()!) }}</strong>
            @if (isTrackingStopped()) {
              <span>
                {{
                  tookTooLong()
                    ? 'Ainda processando os documentos. Volte em alguns minutos ou clique em Atualizar.'
                    : 'Não conseguimos ver o andamento agora. Clique em Atualizar.'
                }}
                <button type="button" class="gates__link" (click)="load()">Atualizar</button>
              </span>
            } @else {
              <span>
                Isso leva alguns minutos. Pode deixar esta tela aberta: os gates são recalculados
                sozinhos assim que o processamento terminar.
              </span>
            }
          </div>
        </div>
      }
    </div>
    @if (g.blockedBy.length) {
      <!-- Aviso, não decisão (06/10/2026): o deal não é rejeitado sozinho. -->
      <div class="gates__alert" role="alert">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <div>
          <strong>
            Este deal é barrado por {{ g.blockedBy.length }}
            {{ g.blockedBy.length === 1 ? 'gate' : 'gates' }}: {{ joinGateNames(g.blockedBy) }}.
          </strong>
          <span>
            Nada é rejeitado automaticamente. Rejeitar (com o motivo) ou seguir com o deal é decisão
            do time.
          </span>
        </div>
      </div>
    }
    <table class="gates__table">
      <thead>
        <tr>
          <th>Gate</th>
          <th>Valor da empresa</th>
          <th>Limite</th>
          <th>Resultado</th>
        </tr>
      </thead>
      <tbody>
        @for (gate of g.gates; track gate.key) {
          <tr>
            <td>
              <strong>{{ gate.label }}</strong>
              <span class="gates__source">{{ gate.source }}</span>
            </td>
            <td class="gates__num">{{ describeValue(gate) }}</td>
            <td class="gates__num">{{ describeLimit(gate) }}</td>
            <td>
              <span class="gate-tag gate-tag--{{ gate.result }}">
                <i class="pi {{ labels[gate.result].icon }}" aria-hidden="true"></i>
                {{ labels[gate.result].text }}
              </span>
              @if (gate.note) {
                <span class="gates__note">{{ gate.note }}</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
    <p class="gates__foot">
      Um gate que não atende barra o deal, mas não o rejeita: a decisão é do time. Os limites são
      definidos em Gerenciamento › Parametrização › Gates do deal.
    </p>
  }
</section>
